import axios from "axios";
import { getError } from './erreurs.js'

export const Service = {
  get,
  post,
  put,
  deleteOne
};

function get(apiEndpoint, headers) {
  return axios.get(apiEndpoint, headers)
    .then(response => response)
    .catch(err => {
      if (err.response && err.response.data && err.response.data.message) { err.response.data.message = getError(err.response.data.code) }
      throw err
      // let error = err;
      // error.response = err.response && err.response.data && err.response.data.message ? Object.assign(err.response, { data: { message: getError(err.response.data.code) } }) : Object.assign({}, error.response, { data: { message: getError(1) } })
      // throw error
    })
}

function post(apiEndpoint, payload, headers) {
  return axios.post(apiEndpoint, payload, headers)
    .then(response => response)
    .catch(err => {
      if (err.response && err.response.data && err.response.data.message) { err.response.data.message = getError(err.response.data.code) }
      throw err
    })
}

function put(apiEndpoint, payload, headers) {
  return axios.put(apiEndpoint, payload, headers)
    .then(response => response)
    .catch(err => {
      if (err.response && err.response.data && err.response.data.message) { err.response.data.message = getError(err.response.data.code) }
      throw err
    })
}

function deleteOne(apiEndpoint, headers) {
  return axios
    .delete(apiEndpoint, headers)
    .then(response => response)
    .catch(err => {
      if (err.response && err.response.data && err.response.data.message) { err.response.data.message = getError(err.response.data.code) }
      throw err
    })
}
